import {Alert, Box, Divider, Paper, Stack, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const features = [
    {
      title: 'Filer Summary',
      subtitle:
        'Candidate Info, Office Sought, Committee Info, and Latest Financial Summary'
    },
    {
      title: 'Reports',
      subtitle:
        "List of campaign finance reports filed with OCPF by the filer"
    },
    {
      title: 'Contributions',
      subtitle:
        'List of contributions received by the filer'
    },
    {
        title: 'Expenditures',
        subtitle:
          'List of expenditures made by the filer'
      },
      {
        title: 'Filer Documents',
        subtitle:
          'List of public documents and forms filed by the filer'
      },
    {
        title: 'Audit Issues',
        subtitle:
          'List of audit issues and the related documents to resolve the issues'
      },
  ];

const FilerGeneralOverview = (): JSX.Element => {

     return (
     <Grid container marginTop={2} marginLeft={2} display={'flex'} justifyContent={'flex-start'}>   
        <Grid 
            padding={3}
            size={10}
            component={Paper} 
            boxShadow={1} 
            >
            <Alert icon={false} severity="info"  sx={{marginBottom: 3}} >
                <Stack direction="row" spacing={1}>
                    <ArrowBackIcon sx={{ fontSize: 28 }} />
                    <Typography variant='h6' fontWeight={550} marginBottom={2}>
                        Please search or select a filer on the list for filer details.
                    </Typography>
                </Stack>
            </Alert>
            <Divider/>
            <Box margin={4}>
                <Typography
                    variant="h6"
                    fontWeight={550}
                    gutterBottom
                >
                    OCPF Filers - Overview
                </Typography>
                <Typography
                    variant="h6"
                    color={'text.secondary'}
                    >
                    For each candidate and committee filing reports with OCPF, the following information is displayed in their dedicated profile pages.
                </Typography>
            </Box>
            <Box margin={4}>
                {
                    features.map((item, i) => (
                        <Stack direction="row" spacing={1} marginBottom={1} key={i}>
                            <CheckCircleIcon color="action" />
                            <Typography variant='subtitle1' fontWeight={550} marginBottom={2}>
                                {item.title}
                            </Typography>
                            <Typography variant='subtitle1' marginBottom={2}>
                                {item.subtitle}
                            </Typography>
                        </Stack>
                    ))
                }
            </Box>
        </Grid>
    </Grid>
  );
};

export default FilerGeneralOverview;